import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = [
    "modal", "fileInput", "uploadArea", "selectedFile", "fileName",
    "importButton", "importButtonText", "resultsArea",
    "successSummary", "successMessage", "errorsArea", "errorsList"
  ]

  static values = {
    adminId: String,
    rotationId: String
  }

  connect() {
    console.log('ClientAssignmentsImportController connected', this.element)
    console.log('Has modal target:', this.hasModalTarget)
    this.csrfToken = document.querySelector('meta[name="csrf-token"]').content
    this.selectedFile = null
  }

  openModal() {
    console.log('openModal called, hasModalTarget:', this.hasModalTarget)
    if (this.hasModalTarget) {
      console.log('Opening modal:', this.modalTarget)
      this.modalTarget.showModal()
    } else {
      console.error('Modal target not found!')
    }
  }

  closeModal() {
    if (this.hasModalTarget) {
      this.modalTarget.close()
    }
  }

  fileSelected(event) {
    const file = event.target.files[0]
    if (!file) return

    const validTypes = ['.csv', '.xlsx', '.xls']
    const ext = file.name.toLowerCase().slice(file.name.lastIndexOf('.'))

    if (!validTypes.includes(ext)) {
      this.showError('Tipo de arquivo inválido. Use CSV ou Excel (.xlsx, .xls).')
      this.clearFile()
      return
    }

    this.selectedFile = file
    this.fileNameTarget.textContent = file.name
    this.selectedFileTarget.classList.remove('hidden')
    this.importButtonTarget.disabled = false
    this.hideResults()
  }

  clearFile() {
    this.selectedFile = null
    this.fileInputTarget.value = ''
    this.selectedFileTarget.classList.add('hidden')
    this.importButtonTarget.disabled = true
  }

  async import() {
    if (!this.selectedFile) return

    this.setLoading(true)
    this.hideResults()

    const formData = new FormData()
    formData.append('file', this.selectedFile)

    try {
      const response = await fetch(
        `/real_estate_admin/${this.adminIdValue}/lead_assignment_rotations/${this.rotationIdValue}/process_import_client_assignments`,
        {
          method: 'POST',
          headers: {
            'X-CSRF-Token': this.csrfToken
          },
          body: formData
        }
      )

      const data = await response.json()
      this.displayResults(data)

      if (data.assignments && data.assignments.length > 0) {
        this.updateMainList(data.assignments)
      }
    } catch (error) {
      console.error('Import error:', error)
      this.displayResults({
        status: 'error',
        message: 'Erro ao processar importação. Tente novamente.',
        successful_count: 0,
        failed_count: 0,
        errors: []
      })
    } finally {
      this.setLoading(false)
    }
  }

  setLoading(loading) {
    this.importButtonTarget.disabled = loading
    this.importButtonTextTarget.textContent = loading ? 'Importando...' : 'Importar'

    if (loading) {
      this.importButtonTarget.classList.add('opacity-75', 'cursor-not-allowed')
    } else {
      this.importButtonTarget.classList.remove('opacity-75', 'cursor-not-allowed')
    }
  }

  displayResults(data) {
    this.resultsAreaTarget.classList.remove('hidden')

    if (data.successful_count > 0) {
      this.successSummaryTarget.classList.remove('hidden')
      this.successMessageTarget.textContent = data.message
    } else {
      this.successSummaryTarget.classList.add('hidden')
    }

    if (data.errors && data.errors.length > 0) {
      this.errorsAreaTarget.classList.remove('hidden')
      this.errorsListTarget.innerHTML = data.errors.map(err =>
        `<li class="py-1"><span class="font-medium">Linha ${err.row}:</span> ${this.escapeHtml(err.message)}</li>`
      ).join('')
    } else {
      this.errorsAreaTarget.classList.add('hidden')
    }

    if (data.status === 'success') {
      this.clearFile()
      this.showSuccess(data.message)
    } else if (data.successful_count > 0) {
      this.showSuccess(`${data.successful_count} atribuições importadas com sucesso.`)
    }
  }

  hideResults() {
    this.resultsAreaTarget.classList.add('hidden')
    this.errorsAreaTarget.classList.add('hidden')
    this.successSummaryTarget.classList.add('hidden')
  }

  updateMainList(assignments) {
    const mainController = document.querySelector('[data-controller~="client-assignments"]')
    if (mainController) {
      const controller = this.application.getControllerForElementAndIdentifier(
        mainController, 'client-assignments'
      )
      if (controller && typeof controller.addAssignmentToList === 'function') {
        assignments.forEach(assignment => {
          controller.addAssignmentToList(assignment)
        })
      }
    }
  }

  escapeHtml(text) {
    const div = document.createElement('div')
    div.textContent = text
    return div.innerHTML
  }

  showSuccess(message) {
    this.showToast(message, 'success')
  }

  showError(message) {
    this.showToast(message, 'error')
  }

  showToast(message, type) {
    window.showNotification(message, type)
  }
}
